/*
  HMM free gift auto-add (tiered).
  Shopify's "Free Pound of Ground Beef" discount gives one free pack per
  threshold reached ($100, $200), counting non-ground-beef items only.
  This keeps the right number of free packs in the cart, confirms Shopify made
  them $0 (anything not free is taken back out), and never re-adds packs a
  shopper removed during this visit.
  Config comes from window.hmmFreeGift, set in snippets/cart-notification.liquid.
*/
(function () {
  var cfg = window.hmmFreeGift;
  if (!cfg || !cfg.variantId || !window.fetch) return;

  var thresholds = cfg.thresholds || [10000];
  var LAST_KEY = 'hmmGiftLastQty';
  var CAP_KEY = 'hmmGiftCap';
  var SKIP_KEY = 'hmmGiftSkip';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;

  function store(key, value) {
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, value);
    } catch (e) {}
  }
  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function isGiftLine(item) {
    return !!(item.properties && item.properties._hmm_free_gift);
  }
  function isGroundBeef(item) {
    return item.product_id === cfg.productId;
  }
  function setGiftQty(cart, qty) {
    var gift = cart.items.find(isGiftLine);
    if (gift) return post('cart/change.js', { id: gift.key, quantity: qty });
    if (qty <= 0) return Promise.resolve();
    var props = { _hmm_free_gift: '1' };
    if (cfg.label) props['Free gift'] = cfg.label;
    return post('cart/add.js', { items: [{ id: cfg.variantId, quantity: qty, properties: props }] });
  }

  function refreshUI() {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return Promise.resolve();
    }
    return fetch(root + '?sections=cart-icon-bubble,cart-notification-product')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var b = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (b) bubble.innerHTML = b.innerHTML;
        }
        var current = document.querySelector('#cart-notification-product .hmm-mb');
        if (current && sections['cart-notification-product']) {
          var fresh = parser.parseFromString(sections['cart-notification-product'], 'text/html').querySelector('.hmm-mb');
          if (fresh) current.replaceWith(fresh);
        }
      })
      .catch(function () {});
  }

  async function check() {
    if (busy) return;
    busy = true;
    var changed = false;
    try {
      var cart = await getCart();
      var gift = cart.items.find(isGiftLine);
      var giftQty = gift ? gift.quantity : 0;

      var last = parseInt(read(LAST_KEY) || '0', 10);
      if (giftQty < last) store(CAP_KEY, String(giftQty));

      var paidQty = 0;
      var eligible = 0;
      cart.items.forEach(function (item) {
        if (isGroundBeef(item)) {
          if (!isGiftLine(item)) paidQty += item.quantity;
        } else {
          eligible += item.final_line_price;
        }
      });

      var earned = 0;
      thresholds.forEach(function (t) { if (eligible >= t) earned++; });
      var want = Math.max(0, earned - paidQty);
      var cap = read(CAP_KEY);
      if (cap !== null) want = Math.min(want, parseInt(cap, 10));
      var skipKey = eligible + ':' + want;
      if (read(SKIP_KEY) === skipKey && want > giftQty) want = giftQty;

      if (want !== giftQty) {
        await setGiftQty(cart, want);
        changed = true;
        cart = await getCart();
        gift = cart.items.find(isGiftLine);
        if (gift && gift.final_line_price > 0 && gift.price > 0) {
          var paidUnits = Math.ceil(gift.final_line_price / gift.price);
          var freeQty = Math.max(0, gift.quantity - paidUnits);
          store(SKIP_KEY, skipKey);
          await setGiftQty(cart, freeQty);
          cart = await getCart();
          gift = cart.items.find(isGiftLine);
        }
      } else if (gift && gift.final_line_price > 0 && gift.price > 0) {
        var paid = Math.ceil(gift.final_line_price / gift.price);
        await setGiftQty(cart, Math.max(0, gift.quantity - paid));
        changed = true;
        cart = await getCart();
        gift = cart.items.find(isGiftLine);
      }

      store(LAST_KEY, String(gift ? gift.quantity : 0));
      if (changed) await refreshUI();
    } catch (e) {
      if (window.console) console.warn('HMM free gift:', e);
    } finally {
      busy = false;
    }
  }

  function start() {
    check();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(check, 300);
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
